import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row justify-start q-col-gutter-md" }
const _hoisted_2 = { class: "col-grow" }
const _hoisted_3 = { class: "col-auto text-center" }

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import SInput from 'SharedComponents/ui/Input/SInput.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';

type OptionsValueType = null | Array<string> | Array<number>;


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'OptionsParameter' },
  __name: 'Options',
  props: {
    modelValue: {},
    readonly: { type: Boolean },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const { innerValue, emitValue } = useValue<OptionsValueType, Array<string> | Array<number>>(
  props,
  emit,
  { transform: (v) => v ?? [] }
);

const addOption = (): void => {
  innerValue.value.push('');
};

const removeOption = (index: number): void => {
  innerValue.value.splice(index, 1);
  emitValue();
};

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, {
    class: _normalizeClass(["s-field-options-list", { 'text-brand-grey': _ctx.readonly }]),
    dense: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item, { class: "row justify-between items-center s-mb-sm" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.label), 1)
            ]),
            _: 1
          }),
          _createVNode(SBtn, {
            disable: _ctx.readonly,
            label: "Добавить вариант",
            type: "light",
            "icon-right": "app:light--add-light",
            onClick: addOption
          }, null, 8, ["disable"])
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(innerValue), (value, index) => {
        return (_openBlock(), _createBlock(_component_q_item, {
          key: index,
          class: "s-mb-xs"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(SInput, {
                      modelValue: _unref(innerValue)[index],
                      "onUpdate:modelValue": [($event: any) => ((_unref(innerValue)[index]) = $event), _unref(emitValue)],
                      outlined: "",
                      dense: "",
                      "hide-bottom-space": "",
                      readonly: _ctx.readonly
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(SBtn, {
                      disable: _ctx.readonly,
                      type: "icon",
                      class: "error",
                      icon: "app:delete-2",
                      onClick: ($event: any) => (removeOption(index))
                    }, null, 8, ["disable", "onClick"])
                  ])
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      (_unref(innerValue).length === 0)
        ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Вы можете задать варианты выбора самостоятельно")
                ])),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})